import { Pipe, PipeTransform } from '@angular/core';
import { replace } from '@df/util/fn/replace';

@Pipe({
    name: 'replace',
    standalone: true
})
export class ReplacePipe implements PipeTransform {
    transform(input: any, pattern: any, replacement: any): any {
        return replace(input, pattern, replacement);
    }
}
